<template>
  <v-col>
    <v-row justify="end">
      <v-btn
        color="primary"
        class="my-6 mr-3"
        @click="downloaGiacenza"
      >Scarica XLS Giacenze</v-btn>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        xl="9"
        class="order-last order-xl-first"
      >
        <v-row>
          <v-card style="width: 100%">
            <v-card-title class="pb-8">
              <v-btn
                color="primary"
                @click="CHANGE_RICAMBI_COMPONENT('Insert')"
              >Nuovo Ricambio</v-btn>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Cerca"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="filteredReplacements"
              class="elevation-1"
              :search="search"
              :items-per-page="100"
              :footer-props="{
      itemsPerPageAllText: 'Tutti',
      itemsPerPageOptions: [15, 50, 100, -1],
      itemsPerPageText: 'Ricambi per pagina',
    }"
            >
              <template v-slot:top>
                <edit-form
                  :item="selectedItem"
                  @edit-submit="triggerSnack($event)"
                />
              </template>

              <template v-slot:item.amount="{ header, item }">
                <v-icon
                  small
                  :class="{'mr-2': true, 'red--text text--darken-1': item.amount == 0, 'green--text text--darken-1': item.amount != 0}"
                  v-if="header.text.length == 0"
                >
                  mdi-circle
                </v-icon>
                <span v-else>{{item.amount}}</span>
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="edit(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>

              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="fetchReplacements"
                >Ricarica</v-btn>
              </template>

              <template v-slot:item.cost="{ item }">
                <span>{{item.cost || '0'}}€</span>
              </template>

              <template v-slot:item.price="{ item }">
                <span>{{item.price || '0'}}€</span>
              </template>

              <template v-slot:item.posix="{ item }">
                <span>{{new Date(item.posix).toLocaleString('it-IT', {'day': '2-digit', 'month': '2-digit', 'year': 'numeric', })}}</span>
              </template>
            </v-data-table>
            <snack-notification :snack="snack" />
          </v-card>
        </v-row>
      </v-col>

      <v-col>
        <filters v-on:filters-changed="applyFilters" />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'

  import EditForm from './EditForm'
  import SnackNotification from './../../SnackNotification'
  import Filters from './Filters.vue'

  export default {
    name: 'Index',
    components: {
      EditForm,
      SnackNotification,
      Filters
    },
    data: () => ({
      today: `${(new Date()).getDate()}-${(new Date()).getMonth() + 1}-${(new Date()).getFullYear()}`,
      search: '',
      headers: [
        { text: '', value: 'amount', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Fornitore', value: 'supplier_name', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Nome', value: 'name', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Modello', value: 'model', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Stato', value: 'state', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Colore', value: 'color', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Costo', value: 'cost', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Prezzo', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Quantità', value: 'amount', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Acquistato il', value: 'posix', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Azioni', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' }
      ],
      replacements: [],
      filteredReplacements: [],
      item: {},
      snack: {
        error: null,
        visible: null,
        message: null
      },
      config: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      }
    }),

    computed: {
      selectedItem() {
        return this.item
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_RICAMBI_COMPONENT',
        'CHANGE_RICAMBI_EDIT'
      ]),

      async fetchReplacements() {
        try {

          let {
            data
          } = await axios.get(`${process.env.VUE_APP_API}/replacements/fetch`, this.config)

          this.replacements = data
        } catch (error) {

          console.log(error)

          this.replacements = []
        }
      },

      async downloaGiacenza() {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/downloads/giacenza-replacements`, this.config)

        var fileURL = window.URL.createObjectURL(new Blob([data]))
        var fileLink = document.createElement('a')

        const name = `[${this.today}]report_giacenze_ricambi.xls`

        fileLink.href = fileURL
        fileLink.setAttribute('download', name)
        document.body.appendChild(fileLink)

        fileLink.click()
      },

      edit(val) {
        this.item = val
        this.CHANGE_RICAMBI_EDIT(true)
      },

      triggerSnack(e) {
        if (e === 'reset') {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })
        } else if (e === 'ok') {

          this.snack = Object.assign({}, {
            visible: true,
            error: false,
            message: 'Articolo modificato correttamente!'
          })
        } else if (e === 'error') {

          this.snack = Object.assign({}, {
            visible: true,
            error: true,
            message: 'Errore nella modifica.'
          })
        }
      },

      async applyFilters(e) {
        if (this.replacements.length === 0) {
          await this.fetchReplacements()
        }

        switch (true) {
          case e.inStock == true && e.notInStock == true:

            this.filteredReplacements = this.replacements
            break

          case e.inStock == true && e.notInStock == false:

            this.filteredReplacements = this.replacements.map(el => {
              if (el.amount > 0) {
                return el
              }
            }).filter(el => el != null)
            break

          case e.inStock == false && e.notInStock == true:

            this.filteredReplacements = this.replacements.map(el => {
              if (el.amount == 0) {
                return el
              }
            }).filter(el => el != null)
            break

          default:
            this.filteredReplacements = []
        }
      }
    }
  }
</script>

<style>
</style>